<template>
  <div>
    <sc-form autocomplete="off" ref="credentialsForm">
      <template slot="fields" slot-scope="{ fields }">
        <div class="mainContent">
          <div class="mainContent__paragraphs">
            <p>
              Olá, esse é o processo de integração passo a passo com a
              transportadora Total Express
            </p>
            <p>
              Para seguirmos, iremos precisar das informações abaixo, você pode
              obter diretamente com a transportadora.
            </p>
          </div>

          <div class="mainContent__inputs">
            <div class="mainContent__inputs__user">
              <label for="user">
                <strong>Usuário API SmartLabel</strong>
              </label>
              <sc-tooltip
                type="is-light"
                position="is-left"
                label="Usuário obtido via suporte da transportadora"
              >
                <sc-icon size="is-small" icon="info-circle" />
              </sc-tooltip>
              <sc-input v-model="username"></sc-input>
            </div>

            <div class="mainContent__inputs__password">
              <label for="user">
                <strong> Senha API SmartLabel </strong>
              </label>
                <sc-tooltip
                  type="is-light"
                  position="is-left"
                  label="Senha obtida via suporte da transportadora"
                >
                  <sc-icon size="is-small" icon="info-circle" />
                </sc-tooltip>
              <sc-input type="password" v-model="password"></sc-input>
            </div>
          </div>
        </div>

        <help-button/>
      </template>

      <template slot="actions" slot-scope="{ isValid }">
        <sc-button
          text="Próximo"
          theme="primary"
          @click="navigateNext"
          type="submit"
        />
      </template>
    </sc-form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScButton,
  ScForm,
  ScField,
  ScInput,
  ScToast,
  ScTooltip,
  ScIcon,
} from '@intelipost-js/secure-components';
import HelpButton from '../help-button/HelpButton.vue';

const { mapState, mapMutations, mapActions } = createNamespacedHelpers(
  'integrations/integrationsStep',
);

export default {
  name: 'sc-credentials',

  data() {
    return {
      username: '',
      password: '',
    };
  },

  computed: {
    ...mapState(['activeStep']),
  },
  methods: {
    ...mapActions(['validateApp']),
    ...mapMutations(['setActiveStep', 'toggleLoading']),

    navigateNext() {
      const args = {
        app_id: this.$router.history.current.params.id,
        app_config: {
          username: this.username,
          password: this.password,
        },
      };

      this.toggleLoading(true);

      this.validateApp(args).then((result) => {
        if (result.ok) {
          this.setActiveStep(1);
        } else {
          ScToast.open({
            message: result.message,
            duration: 20000,
            type: 'is-danger',
          });
        }
      }).finally(() => this.toggleLoading(false));
    },
  },

  components: {
    ScButton,
    ScForm,
    ScField,
    ScInput,
    ScToast,
    ScTooltip,
    ScIcon,
    HelpButton,
  },
};
</script>

<style lang='scss' scoped>
.mainContent {
  display: flex;
  flex-direction: column;
  gap: 40px;

  &__paragraphs {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  &__inputs {
    display: flex;
    flex-direction: column;
    gap: 30px;
    max-width: 400px;

    &__user {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &__password {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-credentials/ScCredentials.vue